"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ItemAdditionalInfo = require("./ItemAdditionalInfo");
Object.keys(_ItemAdditionalInfo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ItemAdditionalInfo[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ItemAdditionalInfo[key];
    }
  });
});
var _ItemLabel = require("./ItemLabel");
Object.keys(_ItemLabel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ItemLabel[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ItemLabel[key];
    }
  });
});
var _ItemShade = require("./ItemShade");
Object.keys(_ItemShade).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ItemShade[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ItemShade[key];
    }
  });
});
